import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

import { HStack, Spacer } from "@/components/Layout";

import { useSoftwareTypeParam } from "../-hooks/useSoftwareType";
import { CreateSoftwareStore } from "../-store/addSoftwareFormStore";

import { InnerNavigation } from "./-components/InnerNavigation";
import { ProgressCard } from "./-components/ProgressCard";
import { SoftwareForm } from "./-components/SoftwareForm";
import { StepProvider } from "./-components/StepProvider";

export const Route = createFileRoute("/_staff/software/add/$type/")({
  component: Form,
});

function Form() {
  const { softwareType } = useSoftwareTypeParam();
  const store = CreateSoftwareStore.createStore();

  useEffect(() => {
    store.getState().actions.reset(softwareType);
  }, [store, softwareType]);

  return (
    <CreateSoftwareStore.Provider value={store}>
      <StepProvider>
        <HStack className="w-full p-6">
          <InnerNavigation />
          <Spacer variant="m" />
          <div className="pb-24 grow min-w-[340px]">
            <SoftwareForm />
          </div>
          <Spacer variant="m" />
          <ProgressCard />
        </HStack>
      </StepProvider>
    </CreateSoftwareStore.Provider>
  );
}
